import React from 'react';
import type { DealStageValue } from '../../types';

// Deal-stage axis (Phase 4, four-axis lead status model, 2026-09-20).
// Replaces the old 8-value lead_status vocabulary's colors/labels.
export const STATUS_COLORS: Record<DealStageValue, { bg: string; fg: string }> = {
  new:         { bg: '#e2e8f0', fg: '#334155' },  // grey
  contacted:   { bg: '#dbeafe', fg: '#1e40af' },  // blue
  qualified:   { bg: '#e0e7ff', fg: '#3730a3' },  // indigo
  quoted:      { bg: '#cffafe', fg: '#155e75' },  // cyan
  negotiation: { bg: '#fef3c7', fg: '#92400e' },  // amber
  nurture:     { bg: '#f1f5f9', fg: '#475569' },  // slate
  won:         { bg: '#dcfce7', fg: '#166534' },  // green
  lost:        { bg: '#fee2e2', fg: '#991b1b' },  // red
};

export const STATUS_LABELS: Record<DealStageValue, string> = {
  new:         'New',
  contacted:   'Contacted',
  qualified:   'Qualified',
  quoted:      'Quoted',
  negotiation: 'Negotiation',
  nurture:     'Nurture',
  won:         'Won',
  lost:        'Lost',
};

interface Props {
  status: DealStageValue;
  lostReason?: string | null;
  onClick?: () => void;
  compact?: boolean;
}

const LeadStatusBadge: React.FC<Props> = ({ status, lostReason, onClick, compact }) => {
  const c = STATUS_COLORS[status] ?? STATUS_COLORS.new;
  const label = STATUS_LABELS[status] ?? status;
  const title = lostReason ? `${label} — ${lostReason.replace(/_/g, ' ')}` : label;

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    background: c.bg,
    color: c.fg,
    borderRadius: 999,
    padding: compact ? '2px 8px' : '4px 12px',
    fontSize: compact ? 11 : 12,
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 0.2,
    cursor: onClick ? 'pointer' : 'default',
    border: '1px solid transparent',
    userSelect: 'none',
  };

  return (
    <span style={style} onClick={onClick} title={title}>
      {label}
    </span>
  );
};

export default LeadStatusBadge;
